import { render, staticRenderFns } from "./SideNavigation.vue?vue&type=template&id=4d92b971&scoped=true&"
import script from "@/components/SideNavigation/SideNavigation.ts?vue&type=script&lang=ts&"
export * from "@/components/SideNavigation/SideNavigation.ts?vue&type=script&lang=ts&"
import style0 from "@/components/SideNavigation/SideNavigation.scss?vue&type=style&index=0&id=4d92b971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d92b971",
  null
  
)

export default component.exports